export default __webpack_public_path__ + "static/sparkle-logo-transparent-400-96-0a2e74349055d30f49864344408df673.gif";